module.exports = __webpack_public_path__ + "assets/checked-icon-bdaf49.svg";